<template>
  <div class="max-w-3xl space-y-4">
    <!-- Page header -->
    <div class="flex items-center gap-3">
      <span class="flex items-center justify-center w-10 h-10 rounded-xl bg-taxiye-100 text-taxiye-500">
        <span class="material-icons-round">manage_accounts</span>
      </span>
      <div>
        <h2 class="text-lg font-semibold text-gray-800">Edit User</h2>
        <p class="text-sm text-gray-500">Update this admin user's details and access.</p>
      </div>
    </div>

    <form @submit.prevent="edit">
      <div class="p-6 space-y-6 bg-white border border-gray-200 rounded-2xl shadow-sm">
        <!-- Name row -->
        <div class="grid grid-cols-1 gap-5 sm:grid-cols-2">
          <label class="block">
            <span class="block text-xs font-semibold tracking-wider text-gray-600 uppercase">First Name</span>
            <input
              v-model="account.firstName"
              class="w-full h-10 px-3 mt-1.5 text-sm text-gray-800 border-gray-300 shadow-sm form-input rounded-xl focus:border-taxiye-300"
              placeholder="Abbay"
            />
          </label>
          <label class="block">
            <span class="block text-xs font-semibold tracking-wider text-gray-600 uppercase">Last Name</span>
            <input
              v-model="account.lastName"
              class="w-full h-10 px-3 mt-1.5 text-sm text-gray-800 border-gray-300 shadow-sm form-input rounded-xl focus:border-taxiye-300"
              placeholder="Kassa"
            />
          </label>
        </div>

        <!-- Email -->
        <label class="block">
          <span class="block text-xs font-semibold tracking-wider text-gray-600 uppercase">Email</span>
          <input
            v-model="account.email"
            class="w-full h-10 px-3 mt-1.5 text-sm text-gray-800 border-gray-300 shadow-sm form-input rounded-xl focus:border-taxiye-300"
            type="email"
            placeholder="contact@sheraton.com"
          />
        </label>

        <!-- Roles -->
        <div>
          <span class="block text-xs font-semibold tracking-wider text-gray-600 uppercase">Roles</span>
          <div v-if="loadingRoles" class="flex items-center mt-2 space-x-2 text-sm text-gray-500">
            <i class="text-base material-icons-round spin">sync</i>
            <span>Loading roles...</span>
          </div>
          <div class="flex flex-wrap gap-2 mt-2" v-else>
            <label
              v-for="role in roles"
              :key="role._id"
              :for="role.roleName"
              class="inline-flex items-center px-3 py-2 text-sm border cursor-pointer rounded-xl transition-colors duration-150"
              :class="roleSelection[role._id]
                ? 'border-taxiye-300 bg-taxiye-50 text-taxiye-700'
                : 'border-gray-200 bg-white text-gray-600 hover:bg-gray-50'"
            >
              <input
                type="checkbox"
                :name="role.roleName"
                v-model="roleSelection[role._id]"
                :id="role.roleName"
                class="mr-2 border-gray-300 rounded form-checkbox text-taxiye-500 focus:border-taxiye-300"
              />
              <span class="font-medium">{{ role.roleName }}</span>
            </label>
          </div>
        </div>
      </div>

      <!-- Actions -->
      <div class="flex items-center justify-between mt-4">
        <back-button></back-button>
        <button
          :disabled="busy"
          class="inline-flex items-center h-10 px-5 text-sm font-semibold text-white shadow-sm rounded-xl transition-colors duration-150"
          :class="
            busy
              ? 'bg-taxiye-200 cursor-not-allowed'
              : 'bg-taxiye-500 hover:bg-taxiye-600'
          "
        >
          <i v-if="busy" class="mr-1 text-base material-icons-round spin">sync</i>
          <i v-else class="mr-1 text-base material-icons-round">save</i>
          <span>Update</span>
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import BackButton from "@/components/BackButton.vue";

export default {
  components: {
    BackButton,
  },
  data() {
    return {
      busy: false,
      vehicleTypes: [],
      account: {
          firstName: "",
          lastName: "",
          email: "",
          active: null,
          roles: []
      },
      roles:[],
      roleSelection: {},
      loadingRoles: true,
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
  },
  created() {
    this.$misc
      .get(`/accounts/${this.id}`)
      .then(response => (this.account = response.data))
      .catch(err => console.log(err));
    this.fetchRoles();
  },
  methods: {
    edit() {
      this.busy = true;
      this.account.roles = Object.entries(this.roleSelection).filter(([, v]) => v).map(([k]) => k)
      this.$misc
        .patch(`accounts/${this.id}`, this.account)
        .then(() => {
          window.flash({
            body: "User updated successfully!",
            type: "success",
          });
          this.$router.push("/accounts");
        })
        .catch(err => {
          window.flash({ body: "Failed to edit account!", type: "error" });
          console.log(err);
        })
        .finally(() => (this.busy = false));
    },
    fetchRoles() {
      this.loadingRoles = true;
      this.$misc
        .get("roles/")
        .then(({ data : { data } }) => {
          this.roles = data
          for (const role of data) {
            this.roleSelection[role._id] = this.account.roles.includes(role._id)
          }
          this.loadingRoles = false;
        });

    },
    changeRole(roleId) {
      if(this.account.roles.includes(roleId)) {
        this.account.roles.splice(this.account.roles.indexOf(roleId), 1);
      } else {
        this.account.roles.push(roleId);      
      }
    }
  },
};
</script>
